import React, { useEffect, useMemo, useState } from 'react';
import { LANGUAGE_CN } from '@/pages/home/_config/config';
import RangePicker from '@/pages/home/components/RangePicker';
import RangeReleaseDate from '@/pages/intelligence/components/RangeReleaseDate';
import RegionSelector from '@/pages/intelligence/components/RegionSelector';
import { GLOBAL_REGION } from '@/pages/intelligence/pages/MobileGameBenchmark/_config/constant';
import { toDateTypeMomentFormat } from '@/pages/intelligence/utils/common';
import {
  GOOGLE_PLATFORM_OPTIONS_TEXT,
  DATA_SOURCE_OPTIONS_TEXT,
  DATA_SOURCE_OPTIONS_ALL_TEXT,
} from '@/pages/intelligence/hooks/useFilterOptionList';
import TimeType from '@/pages/intelligence/components/TimeType';
import GenreSelector from '@intelligence/components/GenreSelectMiddleware';
import DataSourceSelector from '@/pages/intelligence/components/TeaSelector/AnnieSource';
import NumberRange from '@/pages/intelligence/components/NumberRange';
import StreamingPlatformSelector from '@/pages/intelligence/components/TeaSelector/StreamingPlatformSelector';
import PlatformSelector, {
} from '@/pages/intelligence/components/TeaSelector/GooglePlatform';
import PlanSelector from '@/pages/intelligence/components/TeaSelector/Plan';
import RetentionSelector from '@/pages/intelligence/components/TeaSelector/RetentionSelector';
import HeatRangeSelect from '@/pages/intelligence/components/HeatRangeSelect';
import AllCompanySelector from '@/pages/intelligence/components/AllCompanySelector';
import GameSelection from '@/pages/intelligence/components/GameSelectionNew';
import FilterSelect from '@/pages/intelligence/components/FilterSelect';
import GameTypeSelector from '@/pages/intelligence/components/TeaSelector/GameTypeSelector';
import IPOStatusSelector from '@/pages/intelligence/components/TeaSelector/IPOStatusSelector';
import CountrySelector from '@/pages/intelligence/components/TeaSelector/CountrySelector';
import ConsoleDevice from '@/pages/intelligence/components/TeaSelector/ConsoleDevice';
import DigitalSegment from '@/pages/intelligence/components/TeaSelector/DigitalSegment';
import LogicSelectBtn from '@/pages/intelligence/components/LogicSelectBtn';
import DigitalSegmentMultiple from '@/pages/intelligence/components/TeaSelector/DigitalSegmentMultiple';
import GSDSegment from '@/pages/intelligence/components/TeaSelector/GSDSegment';
import ComposedSelect from '@/pages/intelligence/components/ComposedSelect';
import KolPlatform from '@/pages/intelligence/components/TeaSelector/KolPlatform';
import { SingleAreaSelect, MultipleAreaSelect } from '../../TeaSelector/AreaSelect';
import { SingleSourceSelect, MultipleSourceSelect } from '../../TeaSelector/SourceSelect';
import ComposedCountrySelect from '../../ComposedCountrySelect';
import RegionCascaderSelect from '@home/components/RegionCascaderSelect';
import SinglePlatformSelect from '../../TeaSelector/SinglePlatformSelect';
import FollowingGroup from '@/pages/intelligence/components/TeaSelector/FollowingGroup';
import * as filterKeyMap from './_config';
import classNames from 'classnames';
import moment from 'moment';
import './index.scss';
import DataSourceAll from '../../SourceMetricsSelector/DataSourceAll';
import GametypeAll from '../../SourceMetricsSelector/GametypeAll';
import ServiceTypeAll from '../../SourceMetricsSelector/ServiceTypeAll';
import ChannelTypeAll from '../../SourceMetricsSelector/ChannelTypeAll';
import OpinionDataSourceAll from '../../SourceMetricsSelector/OpinionDataSourceAll';
import MetricsDataSourceAll from '../../SourceMetricsSelector/MetricsDataSourceAll';
import MetricsAll from '../../SourceMetricsSelector/MetricsAll';
import GranularityAll from '../../SourceMetricsSelector/GranularityAll';
import FrequencyAll from '../../SourceMetricsSelector/FrequencyAll';
import LanguageSelector from '../../TeaSelector/LanguageSelector';
import AppSelector from '@/pages/intelligence/components/TeaSelector/AppSelector';
import HeatMapCheckbox from '../../TeaSelector/HeatMapCheckbox';
import ShowTopCountriesCheckbox from '../../TeaSelector/ShowTopCountriesCheckbox';
import IconableCheckboxSelect from '../../TeaSelector/IconableCheckboxSelect';
import RevenueGrowth from '../../RevenueGrowth';
import RevenueRange from '../../RevenueRange';
import RevenueRangeUnit from '../../RevenueRangeUnit';
import SensorTowerTagsSelect from '../../SensorTowerTagsSelect';
import CascaderMetricSelect from '../../CascaderMetricSelect';
import { setShortcutOptionFun } from './_config';
import { useDispatch, useIntl, getIntl } from 'umi';
import { FILTER_EXTEND_NAMESPACE } from '@/pages/intelligence/models/filterExtend';
import { DBI_TOPCHARTS } from '@/pages/intelligence/models/topcharts';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import { Bubble } from '@home/components/TeaComponents';
import { RELEASE_DATE_SHORTCUT } from '@/pages/intelligence/pages/TopCharts/PCGames/_config/constant';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import { COMMON_JOINER } from '@intelligence/utils/topchartsUtils';
import CustomDatePicker from '@/pages/intelligence/components/CustomDatePicker';
import { Segment, Switch } from 'tea-component';
import SingleCommonSelector from '../../TeaSelector/SingleCommonSelector';
import MulSelector from '@/pages/intelligence/components/TeaSelector/MultipleSelector';
import MetricsSelection from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/KPITrends/components/MetricsSelection';
import Cascader from '@intelligence/components/Form/components/common/Cascader';
import {
  feachTimeTypeToFilterTimeType,
  COMPARE_PCCONSOLE_RELEASE_DEFAULT,
} from '@/pages/intelligence/utils/common';
import SteamTagsSelector from '@intelligence/components/SteamTagsSelector';
import RegionCountrySelector from '@intelligence/components/RegionCountrySelector';
import { GENRE_SOURCES_METADATA } from '@intelligence/components/GenreSelect/constants';
import HotTagsSource from '@intelligence/components/HotTagsSource';
import { SUMMARY_DISPLAY_ALL } from './StickyHeader/summary';
import { REVENUE_SCOPE_VALUES } from '@intelligence/utils/revenueScope';

import AppMagicIcon from '@intelligence/assets/imgs/dataSource/app-magic.png';
import SensorTowerIcon from '@intelligence/assets/svg/dataSource/sensor-tower.svg';

export const componentDefault = {
  // 6个月， 6周， 30天
  date: [moment().subtract(31, 'day').startOf('date'), moment().subtract(1, 'day').endOf('date')],
  week: [moment().subtract(7, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
  month: [
    moment().subtract(6, 'month').startOf('month'),
    moment().subtract(1, 'months').endOf('month'),
  ],
  year: [
    moment().subtract(3, 'years').startOf('year'),
    moment().subtract(1, 'years').endOf('year'),
  ],
  hour: ['', ''],
} as any;

const DAY_WEEK_MONTH_SEGMENT_OPTIONS = (
  formatMessage: (descriptor: { id: string; }) => string,
) => [
  { text: formatMessage({ id: 'dbi_day' }), value: 'date' },
  { text: formatMessage({ id: 'dbi_week' }), value: 'week' },
  { text: formatMessage({ id: 'dbi_month' }), value: 'month' },
];

const ReangeDate = {} as any;
const ReangeReleaseDate = {} as any;

const renderRangeDate = (props: any) => {
  const {
    key,
    calendarType, // 默认粒度
    value,
    startOfWeek,
    locale,
    onChange,
    componentDefault: componentDefaultProp,
    showSelectType = true,
    typeList = filterKeyMap.RANTE_TYPE,
    startOfDate = '',
    sinceReleaseTime = '',
    earliestDataTime = '',
    isShowAlloftime = true,
    showShortcut,
    disabledDate,
    extendFilterType,
    setIsChangeDefaultType,
    setIsDefaultStateTime,
    rangeTimeOtherStyle = false,
    enableHourSegment = false,
    rangeTimeWrapperClassName,
    normalizeRangeValue,
    selectClassName,
    customComponentClassName,
    rangePickerClassName,
    filterKey,
    onSummaryDisplayChange,
    ...restProps
  } = props || {};

  // console.log('renderRangeDate', props);

  const { visibleinlist } = props;
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();

  const [autoResetShortcutByValueChange, setAutoResetShortcutByValueChange] = useState(false);

  const changeShortcutType = (value: string) => {
    let isShowShortcut = false;
    if (RELEASE_DATE_SHORTCUT?.includes(value)) {
      isShowShortcut = true;
    }
    dispatch({
      type: `${DBI_TOPCHARTS}/setIfShowBaseReleaseTime`,
      payload: isShowShortcut,
    });
    dispatch({
      type: `${DBI_TOPCHARTS}/setSelectedTimeShortcutType`,
      payload: value,
    });
  };

  let type = calendarType;
  let timeVal = value;
  if (value instanceof Object && !(value instanceof Array)) {
    type = feachTimeTypeToFilterTimeType(value.type) || type;
    timeVal = value.value;
  }
  if (!Array.isArray(timeVal) || timeVal?.length !== 2) {
    timeVal = ['', ''];
  }

  // 对外层传进来的时间，一律用moment处理，无效时间使用isValid函数
  timeVal = timeVal?.map((time: any) => {
    const parsedTime = moment(time);
    return parsedTime.isValid() ? parsedTime : '';
  });

  const componentDefaultValues = componentDefaultProp ? componentDefaultProp : componentDefault;

  // const startOfTimeValue =
  //   key === filterKeyMap.RELEASE_TIME || !isShowAlloftime ? '' : startOfDate || '2000-01-01';

  useEffect(() => {
    if (props.value) {
      setIsDefaultStateTime?.(
        'extendFilterType' in props.value && props.value?.extendFilterType === undefined,
      );
    }
  }, [JSON.stringify(props.value)]);

  // 吸顶摘要：按 type 取 toDateTypeMomentFormat 格式化为 "start ~ end" 文本
  const stickyDisplay = useMemo(() => {
    const [start, end] = timeVal || [];
    const fmt = toDateTypeMomentFormat[type] || 'YYYY-MM-DD';
    const isValidStart = moment.isMoment(start) && start.isValid();
    const isValidEnd = moment.isMoment(end) && end.isValid();
    if (!isValidStart && !isValidEnd) return '';
    const startStr = isValidStart ? (start as moment.Moment).format(fmt) : '';
    const endStr = isValidEnd ? (end as moment.Moment).format(fmt) : '';
    if (startStr && endStr) return `${startStr} ~ ${endStr}`;
    return startStr || endStr;
  }, [timeVal?.[0], timeVal?.[1], type]);

  useEffect(() => {
    if (!filterKey || !onSummaryDisplayChange) return;
    onSummaryDisplayChange(filterKey, stickyDisplay);
  }, [filterKey, onSummaryDisplayChange, stickyDisplay]);

  // 优化：避免重复调用 DAY_WEEK_MONTH_SEGMENT_OPTIONS，先缓存基础选项
  const baseSegmentOptions = DAY_WEEK_MONTH_SEGMENT_OPTIONS(formatMessage);
  const segmentOptions = enableHourSegment
    ? [{
      text: (
        <Bubble
          dark
          placementOffset={25}
          className="dbi-bubble-max-width"
          content={formatMessage({ id: 'dbi_hour_tooltip' })}
        >
          <span className="segment-bubble-text">{formatMessage({ id: 'dbi_hour' })}</span>
        </Bubble>
      ),
      value: 'hour',
    }, ...baseSegmentOptions]
    : baseSegmentOptions;

  const hourCustomOption = restProps?.customOption?.hour;
  const hourOverlayClassName = classNames(
    hourCustomOption?.overlayClassName,
    sinceReleaseTime !== '' ? 'dtb-rangepicker-has-firstsince-shotcut' : '',
    restProps?.overlayClassName,
  );
  const mergedCustomOption = {
    ...restProps?.customOption,
    ...(enableHourSegment && hourCustomOption
      ? {
        hour: {
          ...hourCustomOption,
          overlayClassName: hourOverlayClassName,
          startOfWeek: hourCustomOption.startOfWeek ?? startOfWeek ?? 0,
          language:
            hourCustomOption.language ??
            (locale === LANGUAGE_CN ? 'cn' : 'en'),
        },
      }
      : {}),
  };

  return (
    <>
      {visibleinlist && visibleinlist === 2 ? null : (
        <div
          className={classNames({
            'search-item': true,
            'search-item-date': true,
            // Release样式
            'release-time-picker': key === filterKeyMap.RELEASE_TIME,
            [rangeTimeWrapperClassName]:
              type === 'hour' && Boolean(rangeTimeWrapperClassName),
          })}
          key={key}
        >
          {rangeTimeOtherStyle ? (
            <Segment
              className="segment-light details-storerank-segment"
              value={type}
              onChange={(e) => {
                ReangeDate[value.type] = timeVal;
                onChange(key, {
                  value: ReangeDate[e] || componentDefaultValues[e],
                  type: e,
                  extendFilterType,
                });
                // 修改粒度后，先启用组件内跟随 value 变动自动重置选中快捷选项，然后再禁止组件内自动重置逻辑，避免对值的自动处理导致选中项重置为空
                setAutoResetShortcutByValueChange(true);
                setTimeout(() => setAutoResetShortcutByValueChange(false));
              }}
              options={segmentOptions}
            />
          ) : null}
          {rangeTimeOtherStyle ? <span className="dbi_white_space">-</span> : null}
          <RangePicker
            rangeTimeOtherStyle={rangeTimeOtherStyle}
            /** 左侧栏时间粒度 */
            type={type}
            /** 时间值 */
            value={timeVal}
            className="search-border"
            selectClassName={selectClassName}
            customComponentClassName={customComponentClassName}
            rangePickerClassName={rangePickerClassName}
            /** 日周月年的列表 */
            typeList={typeList}
            setIsChangeDefaultType={setIsChangeDefaultType}
            startOfWeek={startOfWeek || 0} // 默认周以周日开始
            language={locale === LANGUAGE_CN ? 'cn' : 'en'}
            // 禁止根据值变动自动重置 shortcut，避免组件二次封装时对值的修改处理逻辑导致变动自动清除了 shortcut 的选中态
            autoResetShortcutByValueChange={autoResetShortcutByValueChange}
            setShortcutOption={() => {
              const shortcuts = setShortcutOptionFun(type, sinceReleaseTime, earliestDataTime);
              return shortcuts;
            }}
            onChange={(value: any, pickerType: string) => {
              let dateValue = ['', ''];
              // 月粒度时，enddate为当前月的最后一天而不是第一天
              if (Array.isArray(value) && value.length === 2) {
                let startDate = value[0];
                let endDate = value[1];
                /** 切换左侧日周月时，因为默认值为空，所以这里默认值给切换的值 */
                if (startDate === '' && endDate === '') {
                  dateValue = componentDefaultValues[pickerType];
                } else {
                  if (pickerType === 'week') {
                    startDate = moment(startDate).startOf('week');
                    endDate = moment(endDate).endOf('week');
                  }
                  if (pickerType === 'month') {
                    endDate = moment(endDate).endOf('month');
                  }
                  if (pickerType === 'year') {
                    endDate = moment(endDate).endOf('year');
                  }
                  dateValue = [startDate, endDate];
                }
              }
              if (typeof normalizeRangeValue === 'function') {
                dateValue = normalizeRangeValue(pickerType, dateValue);
              }
              onChange(key, {
                value: dateValue,
                type: pickerType,
                extendFilterType,
              });
            }}
            /** 是否有左侧的日周月 */
            showSelectType={showSelectType}
            /** 是否展示弹窗左侧时间筛选 */
            showShortcut={key === filterKeyMap.RELEASE_TIME ? true : showShortcut}
            disabledDate={disabledDate}
            /** 不要把 ...restProps放在defaultValue后面*/
            {...restProps}
            customOption={mergedCustomOption}
            defaultValue={componentDefaultValues}
            overlayClassName={classNames(
              sinceReleaseTime !== '' ? 'dtb-rangepicker-has-firstsince-shotcut' : '',
              restProps?.overlayClassName,
            )}
            setTimeShortcutType={changeShortcutType}
            syncInput={false} // 输入时间不直接触发onchange
          />
        </div>
      )}
    </>
  );
};

// compare-pcconsole-releasedate筛选器
const renderRangeReleaseDate = (props: any) => {
  const {
    key,
    value: propsValue,
    startOfWeek,
    locale,
    onChange,
    componentDefault: componentDefaultProp,
    showShortcut,
    disabledDate,
    extendFilterType,
    setIsChangeDefaultType,
    setIsDefaultStateTime,
    rangeTimeOtherStyle = false,
    ...restProps
  } = props || {};
  const { visibleinlist } = props;
  const { formatMessage } = useIntl();

  const type = propsValue?.type;
  const timeVal = propsValue?.value;

  return (
    <>
      {visibleinlist && visibleinlist === 2 ? null : (
        <div
          className={classNames({
            'search-item': true,
            'search-item-date': true,
            'release-time-picker': key === filterKeyMap.RELEASE_TIME,
          })}
          key={key}
        >
          {rangeTimeOtherStyle ? (
            <Segment
              className="segment-light details-storerank-segment"
              value={type}
              onChange={(e) => {
                ReangeReleaseDate[propsValue.type] = timeVal;
                onChange(key, {
                  value: ReangeReleaseDate[e] || COMPARE_PCCONSOLE_RELEASE_DEFAULT[e],
                  type: e,
                  extendFilterType,
                });
              }}
              options={[
                { text: formatMessage({ id: 'dbi_day' }), value: 'date' },
                { text: formatMessage({ id: 'dbi_week' }), value: 'week' },
                { text: formatMessage({ id: 'dbi_month' }), value: 'month' },
              ]}
            />
          ) : null}
          {rangeTimeOtherStyle ? <span className="dbi_white_space">-</span> : null}
          <RangeReleaseDate
            {...restProps}
            types={type}
            value={propsValue}
            onConfirm={(type: IDateType, dateValue: any) => {
              onChange(key, {
                value: dateValue,
                type,
                extendFilterType,
              });
            }}
          />
        </div>
      )}
    </>
  );
};

const renderDatePicker = (props: any) => {
  const {
    key,
    calendarType, // 默认粒度
    value,
    startOfWeek,
    locale,
    onChange,
    componentDefault: componentDefaultProp,
    showSelectType = true,
    typeList = filterKeyMap.RANTE_TYPE,
    startOfDate = '',
    sinceReleaseTime = '',
    earliestDataTime = '',
    isShowAlloftime = true,
    showShortcut,
    disabledDate,
    extendFilterType,
    setIsChangeDefaultType,
    setIsDefaultStateTime,
    showRangePicker = true,
    ...restProps
  } = props || {};

  const dispatch = useDispatch();
  const changeShortcutType = (value: string) => {
    let isShowShortcut = false;
    if (RELEASE_DATE_SHORTCUT?.includes(value)) {
      isShowShortcut = true;
    }
    dispatch({
      type: `${DBI_TOPCHARTS}/setIfShowBaseReleaseTime`,
      payload: isShowShortcut,
    });
    dispatch({
      type: `${DBI_TOPCHARTS}/setSelectedTimeShortcutType`,
      payload: value,
    });
  };

  // console.log('renderRangeDaterenderRangeDate', props);
  let type = calendarType;
  let timeVal = value;
  if (value instanceof Object && !(value instanceof Array)) {
    type = value.type;
    timeVal = value.value;
  }
  if (!Array.isArray(timeVal) || timeVal?.length !== 2) {
    timeVal = ['', ''];
  }

  // 对外层传进来的时间，一律用moment处理，无效时间使用isValid函数
  timeVal = timeVal?.map((time: any) => {
    const parsedTime = moment(time);
    return parsedTime.isValid() ? parsedTime : '';
  });
  const componentDefaultValues = componentDefaultProp ? componentDefaultProp : componentDefault;

  // const startOfTimeValue =
  //   key === filterKeyMap.RELEASE_TIME || !isShowAlloftime ? '' : startOfDate || '2000-01-01';

  useEffect(() => {
    if (props.value) {
      setIsDefaultStateTime?.(
        'extendFilterType' in props.value && props.value?.extendFilterType === undefined,
      );
    }
  }, [JSON.stringify(props.value)]);

  return (
    <div
      className={classNames({
        'search-item': true,
        'search-item-date': true,
        // Release样式
        'release-time-picker': key === filterKeyMap.RELEASE_TIME,
      })}
      key={key}
    >
      <CustomDatePicker
        /** 范围选择器还是单点选择器 */
        showRangePicker={showRangePicker}
        /** 左侧栏时间粒度 */
        type={type}
        /** 时间值 */
        value={timeVal}
        className="search-border"
        /** 日周月年的列表 */
        typeList={typeList}
        setIsChangeDefaultType={setIsChangeDefaultType}
        startOfWeek={startOfWeek || 0} // 默认周以周日开始
        language={locale === LANGUAGE_CN ? 'cn' : 'en'}
        setShortcutOption={() => setShortcutOptionFun(type, sinceReleaseTime, earliestDataTime)}
        onChange={(value: any, type: string) => {
          let dateValue = ['', ''];
          // console.log('dateValuedateValue', dateValue);
          // 月粒度时，enddate为当前月的最后一天而不是第一天
          if (Array.isArray(value) && value.length === 2) {
            let startDate = value[0];
            let endDate = value[1];
            /** 切换左侧日周月时，因为默认值为空，所以这里默认值给切换的值 */
            if (startDate === '' && endDate === '') {
              dateValue = componentDefaultValues[type];
            } else {
              if (type === 'week') {
                startDate = moment(startDate).startOf('week');
                endDate = moment(endDate).endOf('week');
              }
              if (type === 'month') {
                // 月粒度为 1-31号的格式
                endDate = moment(endDate).endOf('month');
              }
              if (type === 'year') {
                endDate = moment(endDate).endOf('year');
              }
              dateValue = [startDate, endDate];
            }
          }

          onChange(key, {
            value: dateValue,
            type,
            extendFilterType,
          });
        }}
        /** 是否有左侧的日周月 */
        showSelectType={showSelectType}
        /** 是否展示弹窗左侧时间筛选 */
        showShortcut={key === filterKeyMap.RELEASE_TIME ? true : showShortcut}
        disabledDate={disabledDate}
        /** 不要把 ...restProps放在defaultValue后面*/
        {...restProps}
        /** 日周月对应的默认值 */
        defaultValue={componentDefaultValues}
        overlayClassName={classNames(
          sinceReleaseTime !== '' ? 'dtb-rangepicker-has-firstsince-shotcut' : '',
          restProps?.overlayClassName,
        )}
        setTimeShortcutType={changeShortcutType}
        syncInput={false} // 输入时间不直接触发onchange
      />
    </div>
  );
};
// 日期粒度
const renderTimeType = (props: any): React.ReactElement => {
  const {
    key,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    locale,
    getLocalText,
    extendFilterType,
    ...restProps
  } = props || {};
  const { value } = valueObj || {};
  return (
    <TimeType
      key={key}
      locale={locale}
      onConfirm={(val: any) => {
        onChange(key, {
          value: val,
          extendFilterType,
        });
      }}
      defaultValue={defaultValue}
      value={value || ''}
      {...restProps}
    />
  );
};

// 国家
const renderRegion = (props: any): React.ReactElement => {
  const {
    key,
    value,
    defaultValue,
    options,
    onChange,
    locale,
    getLocalText,
    extendFilterType,
    disableNoChina,
    globalInfo,
    globalInfoKey,
    hasInfoIcon,
    globalWoChianInfoKey,
    entityType,
    filterKey,
    onSummaryDisplayChange,
    ...restProps
  } = props || {};

  const dispatch = useDispatch();
  const { visibleinlist } = props;

  /**
   * 吸顶摘要：与 RegionSelector 按钮文案一致。
   * - markets 单选且匹配 GLOBAL_REGION → 取常量文案（如 "Global"，不依赖 options）
   * - 其他选中 → 拼接 region / country 名称，>3 个用 "+N" 折叠
   */
  const stickyDisplay = useMemo(() => {
    if (!value) return '';
    const { type, regions = [], markets = [] } = value;

    // 单选 radio：global / global_wo_china —— 从 GLOBAL_REGION 常量取文案
    if (Array.isArray(markets) && markets.length === 1) {
      const single = markets[0];
      const globalItem = GLOBAL_REGION.find((g) => g.area_code === single);
      if (globalItem) {
        return locale === LANGUAGE_CN
          ? globalItem.area_name_ch || globalItem.area_name_en
          : globalItem.area_name_en || globalItem.area_name_ch;
      }
    }

    // 从 options 中收集 text（根据 locale 取 CN 或 EN）
    const getAreaText = (areaItem: any): string => {
      if (!areaItem) return '';
      return locale === LANGUAGE_CN
        ? areaItem.area_name_ch || areaItem.textCN || areaItem.area_name_en || areaItem.text || ''
        : areaItem.area_name_en || areaItem.text || areaItem.area_name_ch || '';
    };
    const getCountryText = (countryItem: any): string => {
      if (!countryItem) return '';
      return locale === LANGUAGE_CN
        ? countryItem.country_name_ch || countryItem.textCN || countryItem.country_name_en || countryItem.text || ''
        : countryItem.country_name_en || countryItem.text || countryItem.country_name_ch || '';
    };

    // region 模式：拼接 region 名
    if (type === 'region' && Array.isArray(regions) && regions.length > 0) {
      const names = regions
        .map((code: string) => {
          const opt = (options || []).find((o: any) => o?.area_code === code);
          return getAreaText(opt) || code;
        })
        .filter(Boolean);
      if (names.length === 0) return '';
      if (names.length <= 3) return names.join(', ');
      return `${names.slice(0, 3).join(', ')} +${names.length - 3}`;
    }

    // market 模式：拼接 market 名
    if (Array.isArray(markets) && markets.length > 0) {
      const names = markets
        .map((code: string) => {
          for (const area of options || []) {
            const found = area?.country_set?.find((c: any) => c?.country_code === code);
            if (found) return getCountryText(found) || code;
          }
          return code;
        })
        .filter(Boolean);
      if (names.length === 0) return '';
      if (names.length <= 3) return names.join(', ');
      return `${names.slice(0, 3).join(', ')} +${names.length - 3}`;
    }

    return '';
  }, [value, options, locale]);

  useEffect(() => {
    if (!filterKey || !onSummaryDisplayChange) return;
    onSummaryDisplayChange(filterKey, stickyDisplay);
  }, [filterKey, onSummaryDisplayChange, stickyDisplay]);

  return (
    <>
      {visibleinlist && visibleinlist === 2 ? null : (
        <RegionSelector
          key={key}
          locale={locale}
          defaultValue={defaultValue}
          onConfirm={(val: any) => {
            dispatch({
              type: `${FILTER_EXTEND_NAMESPACE}/saveIsOperateRegion`,
              payload: true,
            });
            onChange(key, {
              ...(val || {}),
              extendFilterType,
            });
          }}
          options={options}
          value={value}
          disableNoChina={disableNoChina}
          entityType={entityType}
          globalInfo={globalInfo}
          globalInfoKey={globalInfoKey}
          globalWoChianInfoKey={globalWoChianInfoKey}
          hasInfoIcon={hasInfoIcon}
          {...restProps}
        />
      )}
    </>
  );
};

/* 品类筛选器 */
const renderGenretor = (props: any) => {
  const {
    key,
    value,
    options,
    defaultValue,
    onChange,
    locale,
    getLocalText,
    genreData,
    extendFilterType,
    disableIegg = false,
    disableAnnie = false,
    filterKey,
    onSummaryDisplayChange,
    ...restProps
  } = props || {};
  // console.log('renderGenretor', props);
  return (
    <GenreSelector
      key={key}
      locale={locale}
      filterKey={filterKey}
      onSummaryDisplayChange={onSummaryDisplayChange}
      onConfirm={(val: any) => {
        if (JSON.stringify(value) === JSON.stringify(val)) {
          // 没有任何操作时不调用接口
          return;
        }
        onChange(key, {
          ...(val || {}),
          extendFilterType,
        });
      }}
      ref={genreData?.genreRef}
      source={value?.source || 'annie'}
      mainGenres={value?.mainGenres ?? []}
      subGenres={value?.subGenres ?? []}
      level3Genres={value?.level3Genres ?? []}
      level4Genres={value?.level4Genres ?? []}
      level5Genres={value?.level5Genres ?? []}
      onChange={value?.handleGenresChange}
      disableIegg={disableIegg}
      disableAnnie={disableAnnie}
      {...restProps}
    />
  );
};

/* 带数据源切换Segment的品类筛选器 */
const renderGenretorWithSegment = (props: any) => {
  const {
    key,
    value,
    onChange,
    extendFilterType,
    sources = [],
  } = props || {};

  // 当前选中的数据源
  const currentSource = value?.source || sources?.[0] || 'sensortower';

  // 根据 sources 动态生成 Segment 选项
  const segmentOptions = sources.map((source: string) => {
    const metadata = GENRE_SOURCES_METADATA[source];
    return {
      value: source,
      text: (
        <span className="dbi-genre-source-segment-option">
          <img
            className="dbi-genre-source-segment-option__icon"
            src={metadata?.icon}
            alt={metadata?.text}
          />
          <span className="dbi-genre-source-segment-option__text">{metadata?.text || source}</span>
        </span>
      ),
    };
  });

  // Segment 切换处理：更新数据源并清空已选品类
  const handleSegmentChange = (newSource: string): void => {
    if (newSource === currentSource) return;

    onChange(key, {
      source: newSource,
      mainGenres: [],
      subGenres: [],
      level3Genres: [],
      level4Genres: [],
      level5Genres: [],
      extendFilterType,
    });
  };

  return (
    <div className="dbi-genre-source-segment-filter select-item">
      {/* 数据源切换 Segment */}
      <Segment
        className="dbi-genre-source-segment-filter__segment"
        value={currentSource}
        options={segmentOptions}
        onChange={(val) => handleSegmentChange(val as string)}
      />

      {/* 中划线分隔符 */}
      <span className="dbi-genre-source-segment-filter__divider">-</span>

      {/* 品类筛选器 - 复用 renderGenretor，保持所有 props 原封不动传递 */}
      {renderGenretor(props)}
    </div>
  );
};

const renderDataSource = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    locale,
    getLocalText,
    extendFilterType,
    singleType = 'multiple',
    isSearchItemMargin = false,
    showDatabrain,
    filterKey,
    onSummaryDisplayChange,
    ...restProps
  } = props || {};
  const { value } = valueObj || {};

  /**
   * 吸顶摘要：与 AnnieSource(multiple) 按钮一致。
   * 全选 → __ALL__；单选 → 选项 text；多选 → 数字；空 → ''
   */
  const stickyDisplay = useMemo(() => {
    const selected: string[] = Array.isArray(value) ? value : [];
    const fullOptions =
      options && options.length > 0
        ? options
        : showDatabrain
        ? DATA_SOURCE_OPTIONS_ALL_TEXT
        : DATA_SOURCE_OPTIONS_TEXT;
    // 与 MultipleSelector 内部兜底一致：过滤无效值
    const validValues = selected.filter((v) => fullOptions.some((o: any) => o?.value === v));
    const effective = validValues.length > 0 ? validValues : fullOptions.map((o: any) => o?.value);
    if (effective.length === 0) return '';
    if (effective.length === fullOptions.length) return SUMMARY_DISPLAY_ALL;
    if (effective.length >= 2) return String(effective.length);
    const opt = fullOptions.find((o: any) => o?.value === effective[0]);
    return opt?.text || effective[0] || '';
  }, [value, options, showDatabrain]);

  useEffect(() => {
    if (!filterKey || !onSummaryDisplayChange) return;
    onSummaryDisplayChange(filterKey, stickyDisplay);
  }, [filterKey, onSummaryDisplayChange, stickyDisplay]);

  return (
    <DataSourceSelector
      {...restProps}
      type={singleType}
      key={key}
      locale={locale}
      showDatabrain={showDatabrain}
      onConfirm={(val: any) => {
        onChange(key, {
          value: val,
          extendFilterType,
        });
      }}
      defaultValue={defaultValue}
      value={value || []}
      isSearchItemMargin={isSearchItemMargin}
    />
  );
};

const renderDataSourceSingle = (props: any) => {
  const {
    key,
    value: valueObj,
    defaultValue,
    onChange,
    locale,
    getLocalText,
    extendFilterType,
    options,
    showDatabrain,
    filterKey,
    onSummaryDisplayChange,
    ...restProps
  } = props || {};
  const { value } = valueObj || {};

  /**
   * 吸顶摘要：与 AnnieSource(single) 按钮一致。
   * 注意：options 中的 text 可能是 i18n key（如 'dbi_xxx'），需手动 formatMessage。
   */
  const stickyDisplay = useMemo(() => {
    const single = Array.isArray(value) ? value[0] : value;
    if (single === undefined || single === null || single === '') return '';
    const fullOptions =
      options && options.length > 0
        ? options
        : showDatabrain
        ? DATA_SOURCE_OPTIONS_ALL_TEXT
        : DATA_SOURCE_OPTIONS_TEXT;
    const opt = fullOptions.find((o: any) => o?.value === single);
    // options 中的 text 可能是 i18n key，按 'dbi_' 前缀手动翻译一次（按钮侧由 Bubble 外层 formatMessage 渲染）
    const rawText = opt?.text;
    if (typeof rawText === 'string' && rawText.startsWith('dbi_')) {
      try {
        return getIntl().formatMessage({ id: rawText });
      } catch {
        return rawText;
      }
    }
    return typeof rawText === 'string' ? rawText : String(single);
  }, [value, options, showDatabrain]);

  useEffect(() => {
    if (!filterKey || !onSummaryDisplayChange) return;
    onSummaryDisplayChange(filterKey, stickyDisplay);
  }, [filterKey, onSummaryDisplayChange, stickyDisplay]);

  return (
    <DataSourceSelector
      {...restProps}
      type={'single'}
      key={key}
      locale={locale}
      options={options}
      showDatabrain={showDatabrain}
      onConfirm={(val: any) => {
        onChange(key, {
          value: val,
          extendFilterType,
        });
      }}
      defaultValue={defaultValue}
      value={value || defaultValue?.value || []}
    />
  );
};
const renderPlatform = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    locale,
    getLocalText,
    extendFilterType,
    filterKey,
    onSummaryDisplayChange,
    variant,
    ...restProps
  } = props || {};
  const { value } = valueObj || {};

  const { formatMessage } = useIntl();

  // 吸顶摘要：与 GooglePlatform 按钮一致（选项固定为 appstore / googleplay）
  const stickyDisplay = useMemo(() => {
    const selected: string[] = Array.isArray(value) ? value : [];
    const fullOptions = GOOGLE_PLATFORM_OPTIONS_TEXT;
    const validValues = selected.filter((v) => fullOptions.some((o: any) => o?.value === v));
    const effective = validValues.length > 0 ? validValues : fullOptions.map((o: any) => o?.value);
    if (effective.length === 0) return '';
    if (effective.length === fullOptions.length) return SUMMARY_DISPLAY_ALL;
    if (effective.length >= 2) return String(effective.length);
    const opt = fullOptions.find((o: any) => o?.value === effective[0]);
    return opt?.text || effective[0] || '';
  }, [value, formatMessage]);

  useEffect(() => {
    if (!filterKey || !onSummaryDisplayChange) return;
    onSummaryDisplayChange(filterKey, stickyDisplay);
  }, [filterKey, onSummaryDisplayChange, stickyDisplay]);

  return (
    <PlatformSelector
      key={key}
      locale={locale}
      variant={variant}
      onConfirm={(val: any) => {
        onChange(key, {
          value: val,
          extendFilterType,
        });
      }}
      defaultValue={defaultValue}
      value={value || []}
      {...restProps}
    />
  );
};

const renderCascader = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    onChange,
    visibleinlist,
    ref,
    groupName,
    itemName,
    groupNameLocaleKey,
    itemNameLocaleKey,
    filterKey,
    onSummaryDisplayChange,
    renderKey,
    ...restProps
  } = props || {};
  const intl = getIntl();
  const cascaderGroupName =
    groupNameLocaleKey && intl ? intl.formatMessage({ id: groupNameLocaleKey }) : groupName;
  const cascaderItemName =
    itemNameLocaleKey && intl ? intl.formatMessage({ id: itemNameLocaleKey }) : itemName;
  const {
    children,
    hasSelectAll,
    hasSearch,
    hasShortcut,
    mainCategory = '',
    subCategory = '',
    shortcutOptions,
    displaySearchParentText,
    searchTagAutoWidth,
    searchTagWidth,
    shortcutDefaultValue,
    ...restOptions
  } = options || {};

  /**
   * 吸顶摘要：Cascader 级联选择器（platform_cascader 等）。
   * value 结构：Record<string, string[]>（如 { mscience: ['PC'], gsd: [] }）
   *
   * - 总选中数 0      → ''（None）
   * - 每个 group 全选 → __ALL__
   * - 总选中数 1      → 该子项的 label
   * - 其他            → 数字
   */
  const stickyDisplay = useMemo(() => {
    const cascaderValue: Record<string, string[]> = valueObj?.value || {};
    const allOptions: any[] = Array.isArray(children) ? children : [];
    if (!allOptions.length) return '';

    let totalSelected = 0;
    let allGroupsFullChecked = true;
    let singleItemLabel = '';

    for (const group of allOptions) {
      const groupKey = group?.value || '';
      const groupChildren: any[] = Array.isArray(group?.children) ? group.children : [];
      const selected = Array.isArray(cascaderValue[groupKey]) ? cascaderValue[groupKey] : [];
      totalSelected += selected.length;

      if (selected.length !== groupChildren.length) {
        allGroupsFullChecked = false;
      }

      // 记录单选时的 label
      if (selected.length === 1 && totalSelected === 1) {
        const child = groupChildren.find((c: any) => c?.value === selected[0]);
        if (child) {
          const labelKey = child.labelKey;
          if (labelKey && intl) {
            try { singleItemLabel = intl.formatMessage({ id: labelKey }); } catch { singleItemLabel = child.label || selected[0]; }
          } else {
            singleItemLabel = child.label || selected[0];
          }
        }
      }
    }

    if (totalSelected === 0) return '';
    if (allGroupsFullChecked) return SUMMARY_DISPLAY_ALL;
    if (totalSelected === 1 && singleItemLabel) return singleItemLabel;
    return String(totalSelected);
  }, [valueObj?.value, children]);

  useEffect(() => {
    if (!filterKey || !onSummaryDisplayChange) return;
    onSummaryDisplayChange(filterKey, stickyDisplay);
  }, [filterKey, onSummaryDisplayChange, stickyDisplay]);

  return (
    <>
      {visibleinlist && visibleinlist === 2 ? null : (
        <Cascader
          key={renderKey || key}
          {...restOptions}
          {...restProps}
          groupName={cascaderGroupName}
          itemName={cascaderItemName}
          ref={ref}
          hasSelectAll={!!hasSelectAll}
          hasSearch={!!hasSearch}
          hasShortcut={!!hasShortcut}
          displaySearchParentText={!!displaySearchParentText}
          searchTagAutoWidth={searchTagAutoWidth}
          searchTagWidth={searchTagWidth}
          mainCategory={mainCategory}
          subCategory={subCategory}
          options={children}
          shortcutOptions={shortcutOptions}
          shortcutDefaultValue={shortcutDefaultValue || ''}
          value={valueObj?.value}
          field={key}
          hasHighlight={true}
          // 注意这里的特殊性，要包一层value
          onChange={(field: string, value, isClose) => onChange(field, { value }, isClose)}
        />
      )}
    </>
  );
};

const renderKolPlatForm = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    locale,
    getLocalText,
    extendFilterType,
    onFetchSuccess,
    ...restProps
  } = props || {};
  const { value } = valueObj || {};
  return (
    <KolPlatform
      key={key}
      locale={locale}
      onConfirm={(val: any) => {
        onChange(key, {
          value: val,
          extendFilterType,
        });
      }}
      defaultValue={defaultValue}
      onFetchSuccess={(data: any) => {
        if (onFetchSuccess instanceof Function) {
          onFetchSuccess(data);
        }
      }}
      value={value || []}
      {...restProps}
    />
  );
};

const renderStreamingPlatform = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    locale,
    getLocalText,
    extendFilterType,
    ...restProps
  } = props || {};
  const { value } = valueObj || {};
  return (
    <StreamingPlatformSelector
      key={key}
      locale={locale}
      onConfirm={(val: any) => {
        onChange(key, {
          value: val,
          extendFilterType,
        });
      }}
      defaultValue={defaultValue}
      value={value || []}
      {...restProps}
    />
  );
};

const renderPHeat = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    locale,
    getLocalText,
    extendFilterType,
    ...restProps
  } = props || {};
  const { value } = valueObj || {};
  return (
    <HeatRangeSelect
      key={key}
      locale={locale}
      onConfirm={(val: number[]) => {
        onChange(key, {
          value: val,
          extendFilterType,
        });
      }}
      defaultValue={defaultValue}
      value={value || []}
      {...restProps}
    />
  );
};

const renderAllCompany = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    locale,
    getLocalText,
    ref,
    onFetchSuccess,
    extendFilterType,
    getFetchParams,
    filterKey,
    onSummaryDisplayChange,
    ...restProps
  } = props || {};
  const { value } = valueObj || {};

  /**
   * 吸顶摘要：与 AllCompanySelector 按钮一致。
   * 注意：value=[] 代表全选（组件内部会回填全部公司列表）。
   */
  const stickyDisplay = useMemo(() => {
    const selected: string[] = Array.isArray(value) ? value : [];
    if (selected.length === 0) return SUMMARY_DISPLAY_ALL;
    if (selected.length < 3) return selected.join(', ');
    return String(selected.length);
  }, [value]);

  useEffect(() => {
    if (!filterKey || !onSummaryDisplayChange) return;
    onSummaryDisplayChange(filterKey, stickyDisplay);
  }, [filterKey, onSummaryDisplayChange, stickyDisplay]);

  return (
    <AllCompanySelector
      ref={ref}
      key={key}
      locale={locale}
      onConfirm={(val: number[]) => {
        onChange(key, {
          value: val,
          extendFilterType,
        });
      }}
      defaultValue={defaultValue}
      value={value}
      regionType="region"
      regions={['global']}
      onFetchSuccess={(data) => {
        const { min_release_time: minReleaseTime, max_release_time: maxReleaseTime } = data || {};
        if (onFetchSuccess instanceof Function) {
          onFetchSuccess(minReleaseTime, maxReleaseTime);
        }
      }}
      getFetchParams={getFetchParams}
      {...restProps}
    />
  );
};

// SteamTags & GameMode Tags 筛选器
const renderSteamTagSelect = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    ref,
    extendFilterType,
    selectorConfig,
    filterKey,
    onSummaryDisplayChange,
    ...restProps
  } = props || {};
  const { value, logic } = valueObj || {};

  const showLogicSelector = key === 'steam_tag' || key === 'game_engine'; // Show logic selector for Steam Tags and Game Engine, not Game Mode

  /**
   * 吸顶摘要：与 SteamTagsSelector 按钮一致。
   * 全选(>1 且 ===options.length) → __ALL__；<2 个 → 选项 text；>=2 个 → 数字
   */
  const stickyDisplay = useMemo(() => {
    const selected: string[] = Array.isArray(value) ? value : [];
    const fullOptions: any[] = Array.isArray(options) ? options : [];
    const selectedCount = selected.length;
    const tagsCount = fullOptions.length;
    if (!selectedCount) return '';
    if (selectedCount > 1 && selectedCount === tagsCount) return SUMMARY_DISPLAY_ALL;
    if (selectedCount < 2) {
      const currentTag = selected[0];
      const opt = fullOptions.find((item: any) => item?.value === currentTag);
      return (typeof opt?.text === 'string' ? opt.text : opt?.text) || currentTag || '';
    }
    return String(selectedCount);
  }, [value, options]);

  useEffect(() => {
    if (!filterKey || !onSummaryDisplayChange) return;
    onSummaryDisplayChange(filterKey, stickyDisplay);
  }, [filterKey, onSummaryDisplayChange, stickyDisplay]);

  return (
    <SteamTagsSelector
      ref={ref}
      key={key}
      value={value}
      defaultValue={defaultValue}
      options={options}
      selectorConfig={selectorConfig}
      filterLogic={logic || 'AND'}
      showLogicSelector={showLogicSelector}
      onConfirm={(val: string[], newLogic?: 'AND' | 'OR') => {
        onChange(key, {
          value: val,
          logic: newLogic || logic || 'AND',
          extendFilterType,
        });
      }}
      onLogicChange={(newLogic: 'AND' | 'OR') => {
        onChange(key, {
          value,
          logic: newLogic,
          extendFilterType,
        });
      }}
      {...restProps}
    />
  );
};

// 新游戏筛选器-通用
const renderAllGames = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    locale,
    extendFilterType,
    entityType,
    filterKey,
    onSummaryDisplayChange,
    ...restProps
  } = props || {};
  const { params, chooseUpNum, hasShortCut, leftTitleKey } = props;
  const { value, checkedList } = valueObj || {};

  /**
   * 吸顶摘要：GameSelection 按钮文本由内部回调生成，外部无法精确获取，这里做简化。
   * value=[] → __ALL__；有 checkedList → 拼前 2 个游戏名；其他 → 数字
   */
  const stickyDisplay = useMemo(() => {
    const ids: string[] = Array.isArray(value) ? value : [];
    if (ids.length === 0) return SUMMARY_DISPLAY_ALL;
    const names: string[] = Array.isArray(checkedList)
      ? checkedList.map((g: any) => g?.name || g?.game_name || '').filter(Boolean)
      : [];
    if (names.length === 0) return String(ids.length);
    if (names.length <= 2) return names.join(', ');
    return `${names.slice(0, 2).join(', ')} +${names.length - 2}`;
  }, [value, checkedList]);

  useEffect(() => {
    if (!filterKey || !onSummaryDisplayChange) return;
    onSummaryDisplayChange(filterKey, stickyDisplay);
  }, [filterKey, onSummaryDisplayChange, stickyDisplay]);

  // console.log('GameSelection', props);

  return (
    <GameSelection
      key={key}
      locale={locale}
      onConfirm={(val: any[], keywords: string, isSearchAll: boolean, checkedList: any[]) => {
        onChange(key, {
          value: val,
          keywords,
          isSearchAll,
          checkedList,
          extendFilterType,
        });
      }}
      defaultValue={defaultValue}
      value={value}
      checkedList={checkedList}
      entityType={entityType}
      params={params}
      chooseUpNum={chooseUpNum}
      hasShortCut={hasShortCut}
      leftTitleKey={leftTitleKey}
      {...restProps}
    />
  );
};

const renderMyFilter = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    locale,
    getLocalText,
    extendFilterType,
    filterSaveType = '',
    ...restProps
  } = props || {};
  // console.log('renderMyFilter', props);
  const { value } = valueObj || {};
  return (
    <FilterSelect
      key={key}
      locale={locale}
      onChange={(val: any) => {
        onChange(key, {
          value: val,
          extendFilterType,
        });
      }}
      defaultValue={defaultValue}
      value={value}
      filterSaveType={filterSaveType}
      {...restProps}
    />
  );
};

const renderPlan = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    locale,
    getLocalText,
    extendFilterType,
    ...restProps
  } = props || {};
  const { value } = valueObj || {};

  return (
    <PlanSelector
      key={key}
      locale={locale}
      onConfirm={(val: any) => {
        onChange(key, {
          value: val,
          extendFilterType,
        });
      }}
      defaultValue={defaultValue}
      value={value}
      {...restProps}
    />
  );
};

const renderRetention = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    locale,
    getLocalText,
    extendFilterType,
    ...restProps
  } = props || {};
  const { value } = valueObj || {};

  return (
    <RetentionSelector
      key={key}
      locale={locale}
      onConfirm={(val: any) => {
        onChange(key, {
          value: val,
          extendFilterType,
        });
      }}
      defaultValue={defaultValue}
      value={value}
      {...restProps}
    />
  );
};

const renderGameTypeSelector = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    getLocalText,
    extendFilterType,
    ...restProps
  } = props || {};
  const { value } = valueObj || {};

  return (
    <GameTypeSelector
      {...restProps}
      key={key}
      defaultValue={defaultValue}
      value={value}
      onConfirm={(val: string[]) => {
        onChange(key, {
          value: val,
          extendFilterType,
        });
      }}
    />
  );
};

const renderIPOStatusSelector = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    getLocalText,
    extendFilterType,
    ...restProps
  } = props || {};
  const { value } = valueObj || {};

  return (
    <IPOStatusSelector
      {...restProps}
      key={key}
      defaultValue={defaultValue}
      value={value}
      onConfirm={(val: string[]) => {
        onChange(key, {
          value: val,
          extendFilterType,
        });
      }}
    />
  );
};

const renderCountrySelector = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    getLocalText,
    extendFilterType,
    disabled,
    ...restProps
  } = props || {};
  const { value } = valueObj || {};

  return (
    <CountrySelector
      {...restProps}
      key={key}
      options={options}
      defaultValue={defaultValue}
      value={value}
      disabled={disabled}
      onConfirm={(val: string[]) => {
        onChange(key, {
          value: val,
          extendFilterType,
        });
      }}
    />
  );
};
const renderKolLanguage = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    getLocalText,
    extendFilterType,
    disabled,
    ...restProps
  } = props || {};
  const { value } = valueObj || {};

  return (
    <LanguageSelector
      {...restProps}
      key={key}
      options={options}
      defaultValue={defaultValue}
      value={value}
      disabled={disabled}
      onConfirm={(val: string[]) => {
        onChange(key, {
          value: val,
          extendFilterType,
        });
      }}
    />
  );
};

const renderConsoleDevice = (props: any) => {
  const {
    key,
    value: valueObj,
    options = [],
    defaultValue,
    onChange,
    locale,
    getLocalText,
    extendFilterType,
    showIcon,
    btnName,
    newOptions,
    filterKey,
    onSummaryDisplayChange,
    useCascaderStyle,
    cascaderHierarchicalOptions,
    ...restProps
  } = props || {};
  const { value } = valueObj || {};
  const { visibleinlist } = props;

  /**
   * 吸顶摘要：与 ConsoleDevice 按钮一致。
   * 注意：组件对"空值兜底为全选"，这里同样处理。
   */
  const stickyDisplay = useMemo(() => {
    const selected: string[] = Array.isArray(value) ? value : [];
    const fullOptions: any[] = Array.isArray(options) ? options : [];
    if (fullOptions.length === 0) return '';
    const validValues = selected.filter((v) => fullOptions.some((o: any) => o?.value === v));
    // 外部值全部无效时，组件内部会兜底为全选，吸顶同步
    const effective = validValues.length > 0 ? validValues : fullOptions.map((o: any) => o?.value);
    if (effective.length === 0) return '';
    if (effective.length === fullOptions.length) return SUMMARY_DISPLAY_ALL;
    if (effective.length >= 2) return String(effective.length);
    const opt = fullOptions.find((o: any) => o?.value === effective[0]);
    const rawText = opt?.text;
    return typeof rawText === 'string' ? rawText : String(effective[0]);
  }, [value, options]);

  useEffect(() => {
    if (!filterKey || !onSummaryDisplayChange) return;
    onSummaryDisplayChange(filterKey, stickyDisplay);
  }, [filterKey, onSummaryDisplayChange, stickyDisplay]);

  const cascaderOptions = useMemo(() => {
    const sourceOptions = cascaderHierarchicalOptions?.length
      ? cascaderHierarchicalOptions
      : options;
    if (cascaderHierarchicalOptions?.length) {
      return sourceOptions.map((item: any) => {
        const group: any = {
          ...item,
          key: item.value,
          label: item.text,
          icon: String(item.value || '').toLowerCase(),
          isShow: true,
          children: [],
        };
        group.children = (item.children || []).map((child: any) => ({
          ...child,
          key: child.value,
          label: child.text,
          isShow: true,
          parent: group,
        }));
        return group;
      });
    }
    return sourceOptions.map((item: any) => {
      const group: any = {
        ...item,
        key: item.value,
        label: item.text,
        icon: String(item.value || '').toLowerCase(),
        isShow: true,
        hideChildrenCount: true,
        children: [],
      };
      group.children = [{
        ...item,
        key: item.value,
        label: item.text,
        isShow: true,
        parent: group,
      }];
      return group;
    });
  }, [cascaderHierarchicalOptions, options]);

  const cascaderValue = useMemo(
    () => cascaderOptions.reduce((result: Record<string, string[]>, group: any) => ({
      ...result,
      [group.value]: group.children
        .map((child: any) => child.value)
        .filter((childValue: string) => (value || []).includes(childValue)),
    }), {}),
    [cascaderOptions, value],
  );

  if (useCascaderStyle) {
    return (
      <Cascader
        {...restProps}
        options={cascaderOptions}
        value={cascaderValue}
        field={key}
        groupName={'Detailed Platform'}
        itemName={'Detailed Platform'}
        groupWidth={240}
        childWidth={260}
        hasSelectAll={true}
        hasSearch={true}
        mainCategory={'Detailed Platform'}
        subCategory={'Detailed Device'}
        childUnavailableText={cascaderHierarchicalOptions?.length
          ? undefined
          : getIntl().formatMessage({ id: 'dbi_device_dimension_data_unavailable' })}
        isUseClose={true}
        isNoShortcutClear={true}
        customInputDisplayRender={(displayProps: any) => {
          const { isOne, isGroupFullChecked, showNum, showItem, DisplayEmpty } = displayProps;
          return (
            <div className={'dbi-cascader-select-button dbi-select-button'}>
              <span className={'select-button-text'}>{getIntl().formatMessage({ id: 'dbi_platform' })}</span>
              {isOne ? (
                <span>{showItem?.label || showItem?.value}</span>
              ) : isGroupFullChecked ? (
                <span>{getIntl().formatMessage({ id: 'All' })}</span>
              ) : showNum ? (
                <span>{showNum}</span>
              ) : (
                <DisplayEmpty />
              )}
            </div>
          );
        }}
        onChange={(_field: string, cascaderValue: Record<string, string[]>, isClose?: boolean) =>
          onChange(key, {
            value: Object.values(cascaderValue).flat(),
            extendFilterType,
          }, isClose)
        }
      />
    );
  }

  return (
    <>
      {visibleinlist && visibleinlist === 2 ? null : (
        <ConsoleDevice
          key={key}
          options={options}
          locale={locale}
          showIcon={showIcon}
          onConfirm={(val: any) => {
            onChange(key, {
              value: val,
              extendFilterType,
            });
          }}
          defaultValue={defaultValue}
          value={value || []}
          btnName={btnName}
          newOptions={newOptions}
          {...restProps}
        />
      )}
    </>
  );
};

const renderDigitalSegment = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    locale,
    getLocalText,
    extendFilterType,
    ...restProps
  } = props || {};
  const { value } = valueObj || {};
  return (
    <DigitalSegment
      key={key}
      locale={locale}
      onConfirm={(val: any) => {
        onChange(key, {
          value: val,
          extendFilterType,
        });
      }}
      defaultValue={defaultValue}
      value={value}
      {...restProps}
    />
  );
};

const renderDigitalSegmentMultiple = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    locale,
    getLocalText,
    extendFilterType,
    ...restProps
  } = props || {};
  const { value } = valueObj || defaultValue || {};

  const { visibleinlist } = props;

  return (
    <>
      {visibleinlist && visibleinlist === 2 ? null : (
        <DigitalSegmentMultiple
          key={key}
          value={value}
          locale={locale}
          onConfirm={(val: any) => {
            onChange(key, {
              value: val,
              extendFilterType,
            });
          }}
          {...restProps}
        />
      )}
    </>
  );
};

const renderEngageLevelSegmentTwo = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    locale,
    getLocalText,
    extendFilterType,
    ...restProps
  } = props || {};
  const { value } = valueObj || {};
  const { engagementLevelA, engagementLevelB } = value || {};
  const { visibleinlist, showOnlyA } = props;

  return (
    <>
      {visibleinlist && visibleinlist === 2 ? null : (
        <div
          className={classNames('overlap-steam-engagement-level-group', {
            'overlap-steam-engagement-level-group--single': showOnlyA,
          })}
        >
          <DigitalSegment
            className="dbi-logic-select-btn-main-left"
            key={`${filterKeyMap.ENGAGELEVEL_SEGEMENT_TWO}A`}
            locale={locale}
            onConfirm={(val: any) => {
              onChange(`${filterKeyMap.ENGAGELEVEL_SEGEMENT_TWO}A`, {
                value: val,
                extendFilterType,
              });
            }}
            value={engagementLevelA}
            segmentType={`${filterKeyMap.ENGAGELEVEL_SEGEMENT_TWO}A`}
            {...restProps}
          />
          {!showOnlyA && (
            <>
              <LogicSelectBtn {...props} defaultKey="affinity_type" pointKey="GamesWithAffinity" />
              <DigitalSegment
                className="dbi-logic-select-btn-main-right"
                key={`${filterKeyMap.ENGAGELEVEL_SEGEMENT_TWO}B`}
                locale={locale}
                onConfirm={(val: any) => {
                  onChange(`${filterKeyMap.ENGAGELEVEL_SEGEMENT_TWO}B`, {
                    value: val,
                    extendFilterType,
                  });
                }}
                value={engagementLevelB}
                segmentType={`${filterKeyMap.ENGAGELEVEL_SEGEMENT_TWO}B`}
                {...restProps}
              />
            </>
          )}
        </div>
      )}
    </>
  );
};

const renderEngageLevelSegment = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    locale,
    getLocalText,
    extendFilterType,
    ...restProps
  } = props || {};
  const { visibleinlist } = props;
  const { value } = valueObj || {};

  return (
    <>
      {visibleinlist && visibleinlist === 2 ? null : (
        <DigitalSegment
          key={key}
          locale={locale}
          onConfirm={(val: any) => {
            onChange(key, {
              value: val,
              extendFilterType,
            });
          }}
          defaultValue={defaultValue}
          value={value}
          segmentType={'ENGAGELEVEL_SEGEMENT'}
          {...restProps}
        />
      )}
    </>
  );
};

const renderRegionSegment = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    locale,
    getLocalText,
    extendFilterType,
    ...restProps
  } = props || {};
  const { value } = valueObj || {};

  return (
    <DigitalSegment
      key={key}
      locale={locale}
      onConfirm={(val: any) => {
        onChange(key, {
          value: val,
          extendFilterType,
        });
      }}
      defaultValue={defaultValue}
      value={value}
      segmentType={key}
      listHeight={254}
      className="dbi-filter-segment-marginleft10"
      {...restProps}
    />
  );
};

const renderRegionCountrySelector = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    locale,
    getLocalText,
    extendFilterType,
    countryOptions,
    style,
    ...restProps
  } = props || {};
  const { value } = valueObj || {};

  return (
    <RegionCountrySelector
      key={key}
      locale={locale}
      onConfirm={(val: any) => {
        onChange(key, {
          value: val,
          extendFilterType,
        });
      }}
      value={value}
      countryOptions={countryOptions}
      defaultValue={defaultValue}
      listHeight={254}
      style={style}
      {...restProps}
    />
  );
};

// mobile详情storerank切换segment
const renderStoreRankSegment = (props: any) => {
  const { key, value: valueObj, onChange, extendFilterType } = props || {};
  const { value } = valueObj || {};
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { formatMessage } = useIntl();
  const OPTIONS = [
    { value: 'rank', text: formatMessage({ id: 'dbi_segment_rank_trend' }) },
    {
      value: 'market',
      text: formatMessage({ id: 'dbi_segment_market_count' }),
    },
  ];

  return (
    <Segment
      className="segment-light details-storerank-segment"
      value={value}
      options={OPTIONS}
      onChange={(value) => {
        onChange(key, {
          value,
          extendFilterType,
        });
      }}
    />
  );
};

// compare-pcconsole-切换时间筛选器
const renderAlignToRelease = (props: any) => {
  const { key, value: valueObj, onChange, extendFilterType, visibleinlist } = props || {};
  const { value } = valueObj || {};
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { formatMessage } = useIntl();
  return (
    <>
      {visibleinlist && visibleinlist === 2 ? null : (
        <div className="compare-pcconsole-filter-switch">
          <Switch
            value={value}
            onChange={(value) => {
              onChange(key, {
                value,
                extendFilterType,
              });
            }}
          >
            {formatMessage({ id: 'dbi_switch_align_to_release' })}
          </Switch>
        </div>
      )}
    </>
  );
};

const renderRevenueScopeSegment = (props: any) => {
  const { key, showTip = true, extendFilterType, value: valueObj, onChange } = props || {};
  const { formatMessage } = useIntl();
  const { value } = valueObj || {};
  const currentValue = value || REVENUE_SCOPE_VALUES.EXCLUDING;

  const getSegmentOptionText = (localeKey: string, optionValue: string) => {
    const optionTipText =
      optionValue === REVENUE_SCOPE_VALUES.INCLUDING
        ? formatMessage({ id: 'dbi_revenue_scope_tip_including' })
        : formatMessage({ id: 'dbi_revenue_scope_tip_excluding' });

    return (
      <Bubble
        dark
        placement="top"
        placementOffset={10}
        style={{ maxWidth: 450 }}
        content={!showTip ? undefined : <div className="db-tipcontext-content">{optionTipText}</div>}
      >
        <span data-filter-hover-tip-ignore>{formatMessage({ id: localeKey })}</span>
      </Bubble>
    );
  };
  const options = [
    {
      value: REVENUE_SCOPE_VALUES.EXCLUDING,
      text: getSegmentOptionText('dbi_revenue_scope_excluding_store_fees', REVENUE_SCOPE_VALUES.EXCLUDING),
    },
    {
      value: REVENUE_SCOPE_VALUES.INCLUDING,
      text: getSegmentOptionText('dbi_revenue_scope_including_store_fees', REVENUE_SCOPE_VALUES.INCLUDING),
    },
  ];

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Segment
        // className="segment-light"
        className="dbi-filter-segment dbi-filter-segment--revenue-scope"
        options={options}
        value={currentValue}
        onChange={(nextValue) => {
          onChange(key, {
            value: nextValue,
            extendFilterType,
          });
        }}
      />
    </div>
  );
};

const renderRevenueScopeSwitch = (props: any) => {
  const { key, showTip = true, extendFilterType, value: valueObj, onChange } = props || {};
  const { formatMessage } = useIntl();
  const { value } = valueObj || {};
  const currentValue = value || REVENUE_SCOPE_VALUES.EXCLUDING;

  const bubbleContent = (() => {
    if (!showTip) {
      return undefined;
    }

    return (
      <div className="db-tipcontext-content">
        {formatMessage({ id: 'dbi_revenue_scope_tip_excluding' })}
      </div>
    );
  })();

  return (
    <div className="compare-pcconsole-filter-switch dbi-mr5 dbi-mb10">
      <Bubble dark placement="top" placementOffset={10} style={{ maxWidth: 450 }} content={bubbleContent}>
        <Switch
          value={currentValue === REVENUE_SCOPE_VALUES.EXCLUDING}
          onChange={(checked) => {
            onChange(key, {
              value: checked ? REVENUE_SCOPE_VALUES.EXCLUDING : REVENUE_SCOPE_VALUES.INCLUDING,
              extendFilterType,
            });
          }}
        >
          {formatMessage({ id: 'dbi_revenue_scope_exclude_store_fees' })}
        </Switch>
      </Bubble>
    </div>
  );
};

const revenueScopeRendererMap: Record<string, (props: any) => React.ReactElement> = {
  segment: renderRevenueScopeSegment,
  switch: renderRevenueScopeSwitch,
};

const renderRevenueScope = (props: any) => {
  const { controlType = 'segment' } = props || {};

  const revenueScopeRenderer = revenueScopeRendererMap[controlType];

  if (!revenueScopeRenderer) {
    return null;
  }

  return revenueScopeRenderer(props);
};

const renderGSDSegment = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    locale,
    getLocalText,
    extendFilterType,
    ...restProps
  } = props || {};
  const { value } = valueObj || {};

  return (
    <GSDSegment
      key={key}
      locale={locale}
      options={options}
      onConfirm={(val: any) => {
        onChange(key, {
          value: val,
          extendFilterType,
        });
      }}
      defaultValue={defaultValue}
      value={value}
      {...restProps}
    />
  );
};

const renderComposedSelect = (props: any) => {
  const {
    key,
    getLocalText,
    extendFilterType,
    parentOptions,
    childOptionsMap,
    value: valueObj,
    onChange,
    ...restProps
  } = props || {};
  const { value } = valueObj ?? {};
  // console.log('ComposedSelect-props', props);
  return (
    <ComposedSelect
      {...restProps}
      key={key}
      parentOptions={parentOptions}
      childOptionsMap={childOptionsMap}
      value={value}
      onChange={(value: { parent: string; child: string }) => {
        // console.log('ComposedSelect-onChange-value', value);
        onChange(key, { value, extendFilterType });
      }}
    />
  );
};

const renderSingleAreaSelector = (props: any) => {
  const { key, value: valueObj, onChange, extendFilterType, ...restProps } = props || {};
  const { value } = valueObj || {};

  return (
    <SingleAreaSelect
      {...restProps}
      key={key}
      value={value}
      onChange={(payload: string) => {
        onChange(key, {
          value: payload,
          extendFilterType,
        });
      }}
    />
  );
};

// OverlapSteam-players筛选器
const renderOverlapSteamPlayersSegment = (props: any) => {
  const { key, value: valueObj, onChange, extendFilterType } = props || {};

  const { value } = valueObj || {};
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { formatMessage } = useIntl();
  const OPTIONS = [
    {
      text: formatMessage({ id: 'dbi_overlapsteam_segment_played_play' }),
      value: 'played_play',
    },
    {
      text: formatMessage({ id: 'dbi_overlapsteam_segment_played_wishlist' }),
      value: 'played_wishlist',
    },
    {
      text: formatMessage({ id: 'dbi_overlapsteam_segment_wishlisted_play' }),
      value: 'wishlisted_play',
    },
    {
      text: formatMessage({ id: 'dbi_overlapsteam_segment_wishlisted_wishlist' }),
      value: 'wishlisted_wishlist',
    },
  ];

  return (
    <Segment
      className="segment-light dbi-overlap-steam-segment"
      value={value}
      options={OPTIONS}
      onChange={(value) => {
        onChange(key, {
          value,
          extendFilterType,
        });
      }}
    />
  );
};

const renderMultipleAreaSelector = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    getLocalText,
    extendFilterType,
    ...restProps
  } = props || {};
  const { value } = valueObj || {};

  return (
    <MultipleAreaSelect
      {...restProps}
      key={key}
      defaultValue={defaultValue}
      value={value}
      onConfirm={(val: string[]) => {
        onChange(key, {
          value: val,
          extendFilterType,
        });
      }}
    />
  );
};

const renderComposedCountrySelect = (props: any) => {
  const {
    key,
    disabled,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    getLocalText,
    extendFilterType,
    isAll,
    locale,
    filterKey,
    onSummaryDisplayChange,
    ...restProps
  } = props || {};

  const { visibleinlist } = props || {};
  const { value } = valueObj || {};

  /**
   * 吸顶摘要：与 ComposedCountrySelect 按钮一致。
   * - countries 单选匹配 GLOBAL_REGION → 取常量文案（不依赖 options，解决初始化时显示 None 的 bug）
   * - 多选 → 拼接国家名，>3 个用 "+N" 折叠
   */
  const stickyDisplay = useMemo(() => {
    if (!value) return '';
    const { countries = [] } = value || {};
    if (!Array.isArray(countries) || countries.length === 0) return '';

    // global / global_wo_china 走常量，避免依赖 options 加载
    if (countries.length === 1) {
      const single = countries[0];
      const globalItem = GLOBAL_REGION.find((g) => g.area_code === single);
      if (globalItem) {
        return locale === LANGUAGE_CN
          ? globalItem.area_name_ch || globalItem.area_name_en
          : globalItem.area_name_en || globalItem.area_name_ch;
      }
    }

    const getCountryText = (countryItem: any): string => {
      if (!countryItem) return '';
      return locale === LANGUAGE_CN
        ? countryItem.country_name_ch || countryItem.country_name_en || countryItem.country_code || ''
        : countryItem.country_name_en || countryItem.country_name_ch || countryItem.country_code || '';
    };

    const names = countries
      .map((code: string) => {
        for (const area of options || []) {
          const found = area?.country_set?.find((c: any) => c?.country_code === code);
          if (found) return getCountryText(found) || code;
        }
        // options 未就绪时先用 code 兜底，options 到达后会重新计算
        return code;
      })
      .filter(Boolean);

    if (names.length === 0) return '';
    if (names.length <= 3) return names.join(', ');
    return `${names.slice(0, 3).join(', ')} +${names.length - 3}`;
  }, [JSON.stringify(value), options, locale]);

  useEffect(() => {
    if (!filterKey || !onSummaryDisplayChange) return;
    onSummaryDisplayChange(filterKey, stickyDisplay);
  }, [filterKey, onSummaryDisplayChange, stickyDisplay]);

  return (
    <>
      {visibleinlist && visibleinlist === 2 ? null : (
        <ComposedCountrySelect
          {...restProps}
          key={key}
          disabled={disabled}
          options={options}
          defaultValue={defaultValue}
          value={value}
          isAll={isAll}
          onChange={(val: string[]) => {
            onChange(key, {
              value: val,
              extendFilterType,
            });
          }}
        />
      )}
    </>
  );
};

const renderRegionCascaderSelect = (props: any) => {
  const {
    key,
    className,
    disabled,
    value: valueObj,
    options,
    onChange,
    extendFilterType,
    title,
    label,
    placeholder,
    multiCountryText,
    onClickMultiCountry,
    overlayClassName,
    overallGroup,
  } = props || {};

  const { visibleinlist } = props || {};
  const { value } = valueObj || {};

  const handleChangeRegionCascaderSelect = (nextValue: string) => {
    const countries: string[] = [];

    if (nextValue) {
      countries.push(nextValue);
    }

    onChange(key, {
      value: {
        type: 'single',
        countries,
      },
      extendFilterType,
    });
  };

  if (visibleinlist && visibleinlist === 2) {
    return null;
  }

  return (
    <RegionCascaderSelect
      key={key}
      className={className}
      overlayClassName={overlayClassName}
      disabled={disabled}
      label={label || title}
      placeholder={placeholder}
      multiCountryText={multiCountryText}
      regions={options || []}
      overallGroup={overallGroup}
      value={value?.countries?.[0] || ''}
      onChange={handleChangeRegionCascaderSelect}
      onClickMultiCountry={onClickMultiCountry}
    />
  );
};

const renderSinglePlatformSelect = (props: any) => {
  const {
    key,
    style,
    className,
    entityType,
    platforms,
    disabled,
    extendFilterType,
    value: valueObj,
    onChange,
    ...restProps
  } = props ?? {};
  const { value } = valueObj ?? {};

  return (
    <SinglePlatformSelect
      {...restProps}
      key={key}
      style={style}
      className={className}
      entityType={entityType}
      platforms={platforms}
      disabled={disabled}
      value={value}
      onChange={(val: string[]) => {
        onChange(key, {
          value: val,
          extendFilterType,
        });
      }}
    />
  );
};

const renderSingleSourceSelect = (props: any) => {
  const {
    key,
    style,
    className,
    overlayStyle,
    overlayClassName,
    entityType,
    sources,
    disabled,
    extendFilterType,
    value: valueObj,
    onChange,
    ...restProps
  } = props ?? {};
  const { value } = valueObj ?? {};

  return (
    <SingleSourceSelect
      {...restProps}
      key={key}
      style={style}
      className={className}
      overlayStyle={overlayStyle}
      overlayClassName={overlayClassName}
      entityType={entityType}
      sources={sources}
      disabled={disabled}
      value={value}
      onChange={(val: string[]) => {
        onChange(key, {
          value: val,
          extendFilterType,
        });
      }}
    />
  );
};

const renderMultipleSourceSelect = (props: any) => {
  const {
    key,
    style,
    className,
    overlayStyle,
    overlayClassName,
    entityType,
    sources,
    disabled,
    extendFilterType,
    value: valueObj,
    onChange,
    ...restProps
  } = props ?? {};
  const { value } = valueObj ?? {};

  const { visibleinlist } = props;
  return (
    <>
      {visibleinlist && visibleinlist === 2 ? null : (
        <MultipleSourceSelect
          {...restProps}
          key={key}
          style={style}
          className={className}
          overlayStyle={overlayStyle}
          overlayClassName={overlayClassName}
          entityType={entityType}
          sources={sources}
          disabled={disabled}
          value={value}
          onChange={(val: string[]) => {
            onChange(key, {
              value: val,
              extendFilterType,
            });
          }}
        />
      )}
    </>
  );
};

// Source & Metrics Filter
const renderDataSourceFull = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    locale,
    getLocalText,
    extendFilterType,
    ref,
    ...restProps
  } = props || {};
  const { value } = valueObj || {};
  return (
    <DataSourceAll
      ref={ref}
      key={key}
      locale={locale}
      dataSourceAll={options}
      onConfirm={(val: any) => {
        onChange(key, {
          value: val,
          extendFilterType,
        });
      }}
      defaultValue={defaultValue}
      value={value || []}
      {...restProps}
    />
  );
};

const renderOpinionDataSourceFull = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    locale,
    getLocalText,
    extendFilterType,
    ref,
    ...restProps
  } = props || {};
  const { value } = valueObj || {};
  return (
    <OpinionDataSourceAll
      ref={ref}
      key={key}
      locale={locale}
      onConfirm={(val: any) => {
        onChange(key, {
          value: val,
          extendFilterType,
        });
      }}
      defaultValue={defaultValue}
      value={value || []}
      {...restProps}
    />
  );
};

const renderMetricsDataSourceFull = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    locale,
    getLocalText,
    extendFilterType,
    ref,
    ...restProps
  } = props || {};
  const { value } = valueObj || {};
  return (
    <MetricsDataSourceAll
      ref={ref}
      key={key}
      locale={locale}
      onConfirm={(val: any) => {
        onChange(key, {
          value: val,
          extendFilterType,
        });
      }}
      defaultValue={defaultValue}
      value={value || []}
      {...restProps}
    />
  );
};

const renderMetricsFull = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    locale,
    getLocalText,
    extendFilterType,
    ref,
    ...restProps
  } = props || {};
  const { value } = valueObj || {};
  return (
    <MetricsAll
      ref={ref}
      key={key}
      locale={locale}
      onConfirm={(val: any) => {
        onChange(key, {
          value: val,
          extendFilterType,
        });
      }}
      defaultValue={defaultValue}
      value={value || []}
      {...restProps}
    />
  );
};

const renderGametypeeFull = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    locale,
    getLocalText,
    extendFilterType,
    ...restProps
  } = props || {};
  const { value } = valueObj || {};
  return (
    <GametypeAll
      key={key}
      locale={locale}
      onConfirm={(val: any) => {
        onChange(key, {
          value: val,
          extendFilterType,
        });
      }}
      defaultValue={defaultValue}
      value={value || []}
      {...restProps}
    />
  );
};

const renderServicetypeeFull = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    locale,
    getLocalText,
    extendFilterType,
    ...restProps
  } = props || {};
  const { value } = valueObj || {};
  return (
    <ServiceTypeAll
      key={key}
      locale={locale}
      onConfirm={(val: any) => {
        onChange(key, {
          value: val,
          extendFilterType,
        });
      }}
      defaultValue={defaultValue}
      value={value || []}
      {...restProps}
    />
  );
};

const renderChanneltypeFull = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    locale,
    getLocalText,
    extendFilterType,
    ...restProps
  } = props || {};
  const { value } = valueObj || {};
  return (
    <ChannelTypeAll
      key={key}
      locale={locale}
      onConfirm={(val: any) => {
        onChange(key, {
          value: val,
          extendFilterType,
        });
      }}
      defaultValue={defaultValue}
      value={value || []}
      {...restProps}
    />
  );
};

const renderGranularityFull = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    locale,
    getLocalText,
    extendFilterType,
    ...restProps
  } = props || {};
  const { value } = valueObj || {};
  return (
    <GranularityAll
      key={key}
      locale={locale}
      onConfirm={(val: any) => {
        onChange(key, {
          value: val,
          extendFilterType,
        });
      }}
      defaultValue={defaultValue}
      value={value || []}
      {...restProps}
    />
  );
};

const renderFrequencyFull = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    defaultValue,
    onChange,
    locale,
    getLocalText,
    extendFilterType,
    ...restProps
  } = props || {};
  const { value } = valueObj || {};
  return (
    <FrequencyAll
      key={key}
      locale={locale}
      onConfirm={(val: any) => {
        onChange(key, {
          value: val,
          extendFilterType,
        });
      }}
      defaultValue={defaultValue}
      value={value || []}
      {...restProps}
    />
  );
};

// 如 Following分组
const renderGloupSelector = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    onChange,
    locale,
    getLocalText,
    extendFilterType,
    ...restProps
  } = props || {};
  const { value } = valueObj || {};

  return (
    <FollowingGroup
      key={key}
      locale={locale}
      value={value}
      options={options}
      onConfirm={(val: any) => {
        onChange(key, {
          value: val,
          extendFilterType,
        });
      }}
      {...restProps}
    />
  );
};

const renderAppSelector = (props: any) => {
  const {
    key,
    value: valueObj,
    options,
    onChange,
    locale,
    getLocalText,
    extendFilterType,
    ...restProps
  } = props || {};
  const { value } = valueObj || {};

  return (
    <AppSelector
      key={key}
      locale={locale}
      value={value}
      options={options}
      onConfirm={(val: any) => {
        onChange(key, {
          value: val,
          extendFilterType,
        });
      }}
      {...restProps}
    />
  );
};
const renderHeatMapSelect = (props: any) => {
  const { key, value: valueObj, onChange, extendFilterType, ...restProps } = props || {};
  const { value } = valueObj || {};

  return (
    <HeatMapCheckbox
      {...restProps}
      value={value}
      onChange={(payload: boolean) => {
        onChange?.(key, { value: payload, extendFilterType });
      }}
    />
  );
};

const renderShowTopCountriesSelect = (props: any) => {
  const { key, num, value: valueObj, onChange, extendFilterType, ...restProps } = props || {};
  const { value } = valueObj || {};

  return (
    <ShowTopCountriesCheckbox
      {...restProps}
      num={num}
      value={value}
      onChange={(payload: boolean) => {
        onChange?.(key, { value: payload, extendFilterType });
      }}
    />
  );
};

const renderIconableCheckboxSelect = (props: any) => {
  const {
    key,
    locale,
    required,
    sortable,
    options,
    value: valueObj,
    onChange,
    getIconSrc,
    extendFilterType,
    ...restProps
  } = props || {};
  const { value } = valueObj || {};

  return (
    <IconableCheckboxSelect
      {...restProps}
      locale={locale}
      getIconSrc={getIconSrc}
      required={required}
      sortable={sortable}
      options={options}
      value={value}
      onChange={(payload: string[]) => {
        onChange?.(key, { value: payload, extendFilterType });
      }}
    />
  );
};

const renderRevenueRange = (props: any) => {
  const { key, onChange, defaultValue, value: valueObj, filterKey, onSummaryDisplayChange, ...restProps } = props;
  const { value } = valueObj || {};

  // 吸顶摘要：value = { min, max }，展示 "min ~ max" 或单边
  const stickyDisplay = useMemo(() => {
    const min = value?.min;
    const max = value?.max;
    const hasMin = min !== undefined && min !== null && min !== '';
    const hasMax = max !== undefined && max !== null && max !== '';
    if (!hasMin && !hasMax) return '';
    if (hasMin && hasMax) return `${min} ~ ${max}`;
    if (hasMin) return `${min} ~`;
    return `~ ${max}`;
  }, [value?.min, value?.max]);

  useEffect(() => {
    if (!filterKey || !onSummaryDisplayChange) return;
    onSummaryDisplayChange(filterKey, stickyDisplay);
  }, [filterKey, onSummaryDisplayChange, stickyDisplay]);

  return (
    <RevenueRange
      {...restProps}
      value={value}
      onChange={(payload: any) => {
        onChange?.(key, { value: payload });
      }}
    />
  );
};

const renderNumberRange = (props: any) => {
  const { key, onChange, value: valueObj, ...restProps } = props;
  const { value } = valueObj || {};

  return (
    <NumberRange
      {...restProps}
      value={value}
      onChange={(payload: any) => {
        onChange?.(key, { value: payload });
      }}
    />
  );
};

const renderRevenueGrowth = (props: any) => {
  const { key, onChange, defaultValue, value: valueObj, filterKey, onSummaryDisplayChange, ...restProps } = props;
  const { value } = valueObj || {};

  // 吸顶摘要：value = { opt, value }，展示如 "≥ 50%"
  const OPT_LABEL_MAP: Record<string, string> = { '<': '<', '<=': '≤', '>': '>', '>=': '≥', '=': '=' };

  const stickyDisplay = useMemo(() => {
    const opt = value?.opt;
    const val = value?.value;
    if (opt && (val !== undefined && val !== null && val !== '')) {
      const label = OPT_LABEL_MAP[opt] || opt;
      return `${label} ${val}%`;
    }
    return '';
  }, [value?.opt, value?.value]);

  useEffect(() => {
    if (!filterKey || !onSummaryDisplayChange) return;
    onSummaryDisplayChange(filterKey, stickyDisplay);
  }, [filterKey, onSummaryDisplayChange, stickyDisplay]);

  return (
    <RevenueGrowth
      {...restProps}
      value={value}
      onChange={(payload: any) => {
        onChange?.(key, { value: payload });
      }}
    />
  );
};

const renderMobileOverlap = (props: any) => {
  const innerProps = {
    ...props,
    buttonText: 'dbi_metric_mobile_cross_usage',
    placeholderText: 'dbi_input_overlap',
  };
  return renderRevenueGrowth(innerProps);
};

const renderRevenueGrowthTwo = (props: any) => {
  const {
    key,
    onChange,
    defaultValue,
    value: valueObj,
    buttonTextA = 'dbi_overlapsteam_played_play_percent',
    buttonTextB = 'dbi_overlapsteam_played_wishlist_percent',
    ...restProps
  } = props;

  const { isEN } = useIntlExtend();

  const { value } = valueObj || {};

  const {
    revenueGrowthPP,
    revenueGrowthPW,
    revenueGrowthWP,
    revenueGrowthWW,
    segmentName = 'played',
  } = value || {};
  const isPlayed = segmentName === 'played';
  const revenueGrowthA = isPlayed ? revenueGrowthPP : revenueGrowthWP;
  const revenueGrowthB = isPlayed ? revenueGrowthPW : revenueGrowthWW;

  // console.log('renderRevenueGrowthTwo', props);

  return (
    <>
      <RevenueGrowth
        {...restProps}
        className={classNames('dbi-logic-select-btn-main-left dbi-revenue-growth-width100p', {
          'dbi-revenue-growth-played_en': isPlayed && isEN,
          'dbi-revenue-growth-played_cn': isPlayed && !isEN,
          'dbi-revenue-growth-wishlisted_en': !isPlayed && isEN,
          'dbi-revenue-growth-wishlisted_cn': !isPlayed && !isEN,
        })}
        key={`${filterKeyMap.REVENUE_GROWTH_TWO}A`}
        value={revenueGrowthA}
        buttonText={buttonTextA}
        isRevenueGrowthTwo={true}
        onChange={(payload: any) => {
          onChange?.(`${filterKeyMap.REVENUE_GROWTH_TWO}A`, { value: payload });
        }}
      />
      <LogicSelectBtn logicType={'or'} defaultKey="affinity_type" pointKey="GamesWithAffinity" />
      <RevenueGrowth
        {...restProps}
        className={classNames('dbi-logic-select-btn-main-right dbi-revenue-growth-width100p', {
          'dbi-revenue-growth-played_en': isPlayed && isEN,
          'dbi-revenue-growth-played_cn': isPlayed && !isEN,
          'dbi-revenue-growth-wishlisted_en': !isPlayed && isEN,
          'dbi-revenue-growth-wishlisted_cn': !isPlayed && !isEN,
        })}
        key={`${filterKeyMap.REVENUE_GROWTH_TWO}B`}
        value={revenueGrowthB}
        buttonText={buttonTextB}
        isRevenueGrowthTwo={true}
        onChange={(payload: any) => {
          onChange?.(`${filterKeyMap.REVENUE_GROWTH_TWO}B`, { value: payload });
        }}
      />
    </>
  );
};

const renderRevenueRangeUnit = (props: any) => {
  const { key, onChange, defaultValue, value: valueObj, ...restProps } = props;
  const { value } = valueObj || {};

  return (
    <RevenueRangeUnit
      {...restProps}
      value={value}
      onChange={(payload: any) => {
        onChange?.(key, { value: payload });
      }}
    />
  );
};

const renderTipIcon = (props: any) => {
  const {
    content,
    visibleinlist,
    hasLeftText = '',
    placementValue = 'top',
    hasMarginLeft = false,
  } = props;
  const { formatMessage } = useIntlExtend();
  return (
    <>
      {visibleinlist && visibleinlist === 2 ? null : (
        <div
          style={{ width: 'auto', lineHeight: 0 }}
          className={classNames('select-item dbi-filter-tips-icon', {
            'dbi-statsfilter-warp-right-tips-div': hasLeftText,
            'dbi-filter-tip-context-marginleft': hasMarginLeft,
          })}
        >
          {
            <>
              {hasLeftText && (
                <span className="dbi-statsfilter-warp-left-text">
                  {formatMessage({ id: hasLeftText })}
                </span>
              )}
              <TipContext
                Performance="left"
                placement={placementValue}
                tipText={formatMessage({ id: content })}
                AWidth={450}
              />
            </>
          }
        </div>
      )}
    </>
  );
};

const renderSensorTowerTagSelect = (props: any) => {
  const { title, onChange, key, value: valueObj, options, locale, filterKey, onSummaryDisplayChange } = props;
  const { value } = valueObj || {};

  /**
   * 吸顶摘要：与 SensorTowerTagsSelect 按钮一致。
   * 全选(===options.length) → __ALL__；1 个 → 按 locale 取 textCN/text；其他 → 数字
   */
  const stickyDisplay = useMemo(() => {
    const selected: string[] = Array.isArray(value) ? value : [];
    const fullOptions: any[] = Array.isArray(options) ? options : [];
    if (!selected.length) return '';
    if (selected.length === fullOptions.length && fullOptions.length > 0) return SUMMARY_DISPLAY_ALL;
    if (selected.length === 1) {
      const targetTag = fullOptions.find((item: any) => item?.value === selected[0]);
      if (targetTag) {
        return locale === LANGUAGE_CN
          ? targetTag.textCN || targetTag.text || selected[0]
          : targetTag.text || selected[0];
      }
      return selected[0];
    }
    return String(selected.length);
  }, [value, options, locale]);

  useEffect(() => {
    if (!filterKey || !onSummaryDisplayChange) return;
    onSummaryDisplayChange(filterKey, stickyDisplay);
  }, [filterKey, onSummaryDisplayChange, stickyDisplay]);

  return (
    <SensorTowerTagsSelect
      filterKey={key}
      title={title}
      icon={SensorTowerIcon}
      value={value}
      options={options || []}
      onChange={(payload: any) => {
        onChange?.(key, { value: payload });
      }}
    />
  );
};

const renderAppMagicTagSelect = (props: any) => {
  const { key, title, options, value: valueObj, onChange } = props;
  const { value } = valueObj || {};
  return (
    <SensorTowerTagsSelect
      filterKey={key}
      title={title}
      icon={AppMagicIcon}
      options={options || []}
      value={value}
      onChange={(payload: any) => {
        onChange?.(key, { value: payload });
      }}
    />
  );
};

const RenderStreamingGameType = (props: any) => {
  const { buttonTitle, onChange, key, value: valueObj, options, style } = props;
  const { formatMessage } = useIntl();
  const { value } = valueObj || {};
  return (
    <SingleCommonSelector
      buttonTitle={formatMessage({ id: buttonTitle })}
      options={options || []}
      handleClick={(payload: any) => {
        onChange?.(key, { value: payload });
      }}
      value={value}
      style={style}
    />
  );
};

const renderCascaderSelect = (props: any) => {
  const { onChange, key, value: valueObj, options, locale, filterKey, onSummaryDisplayChange } = props;
  const { value = [] } = valueObj || {};
  const language = {
    en: {
      region_title: 'Theme',
      button_region: 'Theme',
    },
    cn: {
      region_title: '主题',
      button_region: '主题',
    },
  };

  /**
   * 吸顶摘要：与 CascaderMetricSelect button3 一致。
   * value 是 string[]：单选 → 找子项 text（i18n key 需翻译）；多选 → 数字
   */
  const stickyDisplay = useMemo(() => {
    const selected: string[] = Array.isArray(value) ? value : [];
    if (!selected.length) return '';
    if (selected.length === 1 && Array.isArray(options)) {
      // 从 options 的 children 中找到对应项
      for (const group of options) {
        if (!Array.isArray(group?.children)) continue;
        const found = group.children.find((child: any) => child?.value === selected[0]);
        if (found) {
          const text = locale === LANGUAGE_CN
            ? found.textCN || found.text || ''
            : found.text || '';
          return typeof text === 'string' && text.startsWith('dbi_')
            ? (getIntl().formatMessage({ id: text }) as string)
            : text || selected[0];
        }
      }
      return selected[0];
    }
    return String(selected.length);
  }, [value, options, locale]);

  useEffect(() => {
    if (!filterKey || !onSummaryDisplayChange) return;
    onSummaryDisplayChange(filterKey, stickyDisplay);
  }, [filterKey, onSummaryDisplayChange, stickyDisplay]);

  return (
    <CascaderMetricSelect
      locale={locale}
      language={language}
      value={value}
      className="dbi-sensotower-cascader-select"
      buttonType="3"
      options={options}
      joiner={COMMON_JOINER}
      titleIcon={SensorTowerIcon}
      onConfirm={(payload: any) => {
        onChange?.(key, { value: payload });
      }}
    />
  );
};

const renderMultipleSelector = (props: any) => {
  const { key, onChange, value: valueObj, options, buttonTitle, extendFilterType } = props;
  const { formatMessage } = useIntl();
  const { value } = valueObj || {};

  return (
    <MulSelector
      value={typeof value === 'string' ? [] : value}
      options={options || []}
      buttonName={buttonTitle ? formatMessage({ id: buttonTitle }) : ''}
      onChange={(values: string[]) => {
        onChange(key, {
          value: values,
          extendFilterType,
        });
      }}
    />
  );
};

const renderMetricsSelection = (props: any) => {
  const {
    key,
    onChange,
    extendFilterType,
    value: valueObj,
    isShowSourceTips = true,
    isSelectShortCut = false,
    overlayClassName,
    hasDatabrainData,
    ...restProps
  } = props;

  const { value = {} } = valueObj || {};
  const {
    types,
    type,
    sources,
    metrics,
    selectedMetricsValue,
    shotSelectValue,
    selectCutVal,
    metricsLoading,
  } = value || {};
  const { visibleinlist } = props;

  return (
    <>
      {visibleinlist && visibleinlist === 2 ? null : (
        <MetricsSelection
          {...restProps}
          loading={metricsLoading === undefined ? false : metricsLoading}
          overlayClassName={overlayClassName}
          hasDatabrainData={hasDatabrainData}
          // value={value}
          type={type}
          // 上次用户选择的值
          metricTypeVals={types}
          sourceVals={sources}
          metricsVals={metrics}
          selectCutVal={selectCutVal}
          isShowSourceTips={isShowSourceTips}
          isSelectShortCut={isSelectShortCut}
          selectedMetricsValue={selectedMetricsValue}
          shotSelectValue={shotSelectValue}
          onChange={(values: any) => {
            onChange(key, {
              value: values,
              extendFilterType,
            });
          }}
        />
      )}
    </>
  );
};

const renderHotTagsSource = (props: any) => {
  const { key, onChange, onHotTagConfirm, hotTagDefaultValue, value: valueObj, locale, options, filterKey, onSummaryDisplayChange, ...restProps } = props;
  const { value } = valueObj || {};
  // valueObj 存在但 value 为空：用户主动清空 / 联动清空，不回退默认；valueObj 为空：初始化阶段才回退
  const selectedName = valueObj ? (value?.name ?? '') : (hotTagDefaultValue?.name ?? '');

  // 吸顶摘要：单选展示 name_cn / name_en，按 locale 切换
  const stickyDisplay = useMemo(() => {
    if (!selectedName) return '';
    if (Array.isArray(options) && options.length > 0) {
      const opt = options.find((item: any) => item?.name === selectedName);
      if (opt) {
        return locale === LANGUAGE_CN
          ? opt.name_cn || opt.name || selectedName
          : opt.name_en || opt.name || selectedName;
      }
    }
    return selectedName;
  }, [selectedName, options, locale]);

  useEffect(() => {
    if (!filterKey || !onSummaryDisplayChange) return;
    onSummaryDisplayChange(filterKey, stickyDisplay);
  }, [filterKey, onSummaryDisplayChange, stickyDisplay]);

  return (
    <HotTagsSource
      {...restProps}
      options={options}
      value={selectedName}
      onConfirm={(option: any) => {
        onChange?.(key, { value: option });
        onHotTagConfirm?.(option);
      }}
    />
  );
};

export default {
  [filterKeyMap.MY_FILTER]: renderMyFilter,
  [filterKeyMap.RANGE_TIME]: renderRangeDate,
  [filterKeyMap.RANGE_RELEASE_TIME]: renderRangeReleaseDate,
  [filterKeyMap.DATE_PICKER]: renderDatePicker,
  [filterKeyMap.TIME_TYPE]: renderTimeType,
  [filterKeyMap.REGION]: renderRegion,
  [filterKeyMap.GENRETOR]: renderGenretor,
  [filterKeyMap.GENRETOR_WITH_SEGMENT]: renderGenretorWithSegment,
  [filterKeyMap.DATASOURCE]: renderDataSource,
  [filterKeyMap.DATASOURCESIM]: renderDataSourceSingle,
  [filterKeyMap.PUBLISHER]: renderDataSourceSingle,
  [filterKeyMap.PLATFORM]: renderPlatform,
  [filterKeyMap.STREAMING_PLATFORM]: renderStreamingPlatform,
  [filterKeyMap.PHEAD_RANG]: renderPHeat,
  [filterKeyMap.ALL_COMPANYS]: renderAllCompany,
  [filterKeyMap.ALL_Games]: renderAllGames,
  [filterKeyMap.PLAN]: renderPlan,
  [filterKeyMap.RETENTION]: renderRetention,
  [filterKeyMap.GAME_TYPE]: renderGameTypeSelector,
  [filterKeyMap.IPO_STATUS]: renderIPOStatusSelector,
  [filterKeyMap.COUNTRY]: renderCountrySelector,
  [filterKeyMap.CONSOLE_DEVICE]: renderConsoleDevice,
  [filterKeyMap.DIGITAL_SEGEMENT]: renderDigitalSegment,
  [filterKeyMap.DIGITAL_SEGMENT_MULTIPLE]: renderDigitalSegmentMultiple,
  [filterKeyMap.ENGAGELEVEL_SEGEMENT]: renderEngageLevelSegment,
  [filterKeyMap.REGION_SEGMENT]: renderRegionSegment,
  [filterKeyMap.REGION_COUNTRY_SELECTOR]: renderRegionCountrySelector,
  [filterKeyMap.ENGAGELEVEL_SEGEMENT_TWO]: renderEngageLevelSegmentTwo,
  [filterKeyMap.STORERANK_SEGEMENT]: renderStoreRankSegment,
  [filterKeyMap.OVERLAPSTEAM_PLAYERS]: renderOverlapSteamPlayersSegment,
  [filterKeyMap.GSD_SEGEMENT]: renderGSDSegment,
  [filterKeyMap.REVENUE_SCOPE]: renderRevenueScope,
  [filterKeyMap.COMPOSED_SELECT]: renderComposedSelect,
  [filterKeyMap.SINGLE_AREA_SELECT]: renderSingleAreaSelector,
  [filterKeyMap.MULTIPLE_AREA_SELECT]: renderMultipleAreaSelector,
  [filterKeyMap.COMPOSED_COUNTRY_SELECT]: renderComposedCountrySelect,
  [filterKeyMap.REGION_CASCADER_SELECT]: renderRegionCascaderSelect,
  [filterKeyMap.SINGLE_PLATFORM_SELECT]: renderSinglePlatformSelect,
  [filterKeyMap.SINGLE_SOURCE_SELECT]: renderSingleSourceSelect,
  [filterKeyMap.MULTIPLE_SOURCE_SELECT]: renderMultipleSourceSelect,
  [filterKeyMap.DATA_SOURCE_FULL]: renderDataSourceFull,
  [filterKeyMap.GAMETYPE_FULL]: renderGametypeeFull,
  [filterKeyMap.SERVICE_TYPE_FULL]: renderServicetypeeFull,
  [filterKeyMap.CHANNEL_TYPE_FULL]: renderChanneltypeFull,
  [filterKeyMap.OPINION_SOURCEDATA_FULL]: renderOpinionDataSourceFull,
  [filterKeyMap.METRICS_SOURCEDATA_FULL]: renderMetricsDataSourceFull,
  [filterKeyMap.METRICS_FULL]: renderMetricsFull,
  [filterKeyMap.QRANULARITY_FULL]: renderGranularityFull,
  [filterKeyMap.FREQ_FULL]: renderFrequencyFull,
  [filterKeyMap.KOL_PLATFORM]: renderKolPlatForm,
  [filterKeyMap.KOL_LANGUAGE]: renderKolLanguage,
  [filterKeyMap.KOL_COUNTRIES]: renderKolLanguage,
  [filterKeyMap.FOLLOWING_GLOUP]: renderGloupSelector,
  [filterKeyMap.APP_SELECTOR]: renderAppSelector,
  [filterKeyMap.HEAT_MAP]: renderHeatMapSelect,
  [filterKeyMap.SHOW_TOP_COUNTRIES]: renderShowTopCountriesSelect,
  [filterKeyMap.ICONABLE_CHECKBOX_SELECT]: renderIconableCheckboxSelect,
  [filterKeyMap.REVENUE_GROWTH]: renderRevenueGrowth,
  [filterKeyMap.MOBILE_OVERLAP]: renderMobileOverlap,
  [filterKeyMap.REVENUE_GROWTH_TWO]: renderRevenueGrowthTwo,
  [filterKeyMap.REVENUE_RANGE]: renderRevenueRange,
  [filterKeyMap.ARPU_RANGE]: renderRevenueRange,
  [filterKeyMap.ACTIVE_USERS_RANGE]: renderNumberRange,
  [filterKeyMap.DOWNLOADS_RANGE]: renderNumberRange,
  [filterKeyMap.RPD_RANGE]: renderNumberRange,
  ...filterKeyMap.assignFilterKeys(filterKeyMap.RETENTION_D_RANGE_KEYS, renderNumberRange),
  [filterKeyMap.REVENUE_RANGE_UNIT]: renderRevenueRangeUnit,
  [filterKeyMap.PCU_RANGE]: renderRevenueRange,
  [filterKeyMap.DIGITAL_RANGE]: renderRevenueRange,
  [filterKeyMap.PHYSICAL_RANGE]: renderRevenueRange,
  [filterKeyMap.PRICE_RANGE]: renderRevenueRange,
  [filterKeyMap.PREMIUM_RANGE]: renderRevenueRange,
  [filterKeyMap.TIPICON]: renderTipIcon,
  [filterKeyMap.SENSOR_TOWER_TAG_ART_STYLE]: renderSensorTowerTagSelect,
  [filterKeyMap.SENSOR_TOWER_TAG_CAMERA_POV]: renderSensorTowerTagSelect,
  [filterKeyMap.SENSOR_TOWER_TAG_PRODUCT_MODEL]: renderSensorTowerTagSelect,
  [filterKeyMap.SENSOR_TOWER_TAG_SETTING]: renderSensorTowerTagSelect,
  [filterKeyMap.SENSOR_TOWER_TAG_TAGS]: renderSensorTowerTagSelect,
  [filterKeyMap.SENSOR_TOWER_TAG_THEME]: renderCascaderSelect,
  [filterKeyMap.SENSOR_TOWER_TAG_MONETIZATION]: renderSensorTowerTagSelect,
  [filterKeyMap.APPMAGIC_TAG_THEMES]: renderAppMagicTagSelect,
  [filterKeyMap.APPMAGIC_TAG_FEATURES]: renderAppMagicTagSelect,
  [filterKeyMap.APPMAGIC_TAG_IP]: renderAppMagicTagSelect,
  [filterKeyMap.APPMAGIC_TAG_SETTINGS]: renderAppMagicTagSelect,
  [filterKeyMap.APPMAGIC_TAG_ART_STYLES]: renderAppMagicTagSelect,
  [filterKeyMap.STREAMING_GAME_TYPE]: RenderStreamingGameType,
  [filterKeyMap.COMPETITOR_PLATFORM]: renderMultipleSelector,
  [filterKeyMap.METRIC_SELECT_FOR_KPI_TREND]: renderMetricsSelection,
  [filterKeyMap.ALIGN_TO_RELEASE]: renderAlignToRelease,
  [filterKeyMap.STEAM_TAGS]: renderSteamTagSelect,
  [filterKeyMap.GAME_MODE]: renderSteamTagSelect,
  [filterKeyMap.GAME_ENGINE]: renderSteamTagSelect,
  [filterKeyMap.CASCADER]: renderCascader,
  [filterKeyMap.HOT_TAGS_SOURCE]: renderHotTagsSource,
};
